// react, react-redux, redux-form
import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

// helpers
import { required, booleonRadioQuestionTrue, booleonRadioQuestionFalse } from "../../../helpers/validate";
import { fileUploaded } from "../../../helpers/actionsHelpers";
import { jumpToError } from "../../../helpers/renderHelpers";

// redux actions
import { saveAppState } from "../../../actions/appActions";

// render components
import RenderField from "../../global/RenderField";

const Chmp = props => {
  const { formData, formName, attachments, handleSubmit, previousPage, saveAppState, isAppSaving, appState } = props;

  const passed = (
    (formData.chmpRequiredFlag && formData.chmpRequiredFlag === 'false' && formData.previousChmpContraveneFlag && formData.previousChmpContraveneFlag === 'false')
    || (formData.chmpRequiredFlag && formData.chmpRequiredFlag === 'true' 
      && formData.chmpApprovedFlag && formData.chmpApprovedFlag === 'true' 
      && formData.chmpContraveneFlag && formData.chmpContraveneFlag === 'false' 
      && formData.previousChmpContraveneFlag && formData.previousChmpContraveneFlag === 'false')
  ) 
  ? true 
  : false;
  
  return (
    <form id={formName} onSubmit={handleSubmit}>
      <div className="sq-form-section">
        <div className="sq-form-section-description">
          <h2>Cultural heritage management plan</h2>
          <p>A Cultural Heritage Management Plan (CHMP) is a written report, prepared by a Heritage Advisor, in accordance with the requirements of the Aboriginal Heritage Act 2006. For further information about CHMPs, or to investigate whether your project requires one, please open this link <a href="https://www.heritage.vic.gov.au/permits/about-chmps" target="_blank" rel="noopener noreferrer">https://www.heritage.vic.gov.au/permits/about-chmps</a> (page will open in a new window).</p>
        </div>
        <div className="sq-form-section">
          <Field
            name="chmpRequiredFlag"
            type="radiobox"
            label={[<span key="1">Is a CHMP required under the <span style={{fontStyle: 'italic'}}>Aboriginal Heritage Act 2006</span> for the proposed works?</span>]}
            component={RenderField}
            templateList={[
              { name: "Yes", value: "true" },
              { name: "No", value: "false" }
            ]}
            validate={required}
            required
          />
          {formData.chmpRequiredFlag === 'true' && (
            <Field
              name="chmpApprovedFlag"
              type="radiobox"
              label="Has a CHMP been approved for proposed works?"
              component={RenderField}
              templateList={[
                { name: "Yes", value: "true" },
                { name: "No (Please contact Heritage Victoria)", value: "false" }
              ]}
              validate={[required, booleonRadioQuestionFalse]}
              required
            />
          )}
          {formData.chmpRequiredFlag === 'true' && formData.chmpApprovedFlag === 'true' && (
            <div className="sq-form-section-description">
              <ul className="list">
                <li className="list-tile info">
                  <div className="list-tile-content">
                    <p>You will be required to upload the supporting document(s) later in this form with the CHMP Approval.</p>
                  </div>
                </li>
              </ul>
            </div>
          )}
          {formData.chmpRequiredFlag === 'true' && formData.chmpApprovedFlag === 'true' && (
            <Field
              name="chmpContraveneFlag"
              type="radiobox"
              label="Do the proposed works contravene the approved CHMP?"
              component={RenderField}
              templateList={[
                { name: "Yes (Please contact Heritage Victoria)", value: "true" },
                { name: "No", value: "false" }
              ]}
              validate={[required, booleonRadioQuestionTrue]}
              required
            />
          )}
          <Field
            name="previousChmpContraveneFlag"
            type="radiobox"
            label="Do the proposed works contravene any previously approved CHMPs?"
            component={RenderField}
            templateList={[
              { name: "Yes (Please contact Heritage Victoria)", value: "true" },
              { name: "No", value: "false" }
            ]}
            validate={[required, booleonRadioQuestionTrue]}
            required
          />
        </div>
      </div>
      <div className="sq-form-control">
        <button type="button" className="sq-form-page-button previous" onClick={previousPage}>Previous</button>
        <button type="submit" className={`sq-form-page-button next ${!passed ? 'disabled' : ''}`} onClick={jumpToError}>Next</button>
      </div>
      <div className="sq-form-control">
        <button type="button" className="sq-form-page-button" onClick={() => saveAppState(appState, formName)} disabled={isAppSaving || fileUploaded(attachments)}>Save and Exit</button>
        <p className="sq-form-page-button-note">An email will be sent to Primary contact email address</p>
      </div>
    </form>
  );
};

const mapStateToProps = (state, formName) => {
  return {
    formData: (state.form[formName.form]) ? state.form[formName.form].values : {},
    attachments: state.service.attachments,
    isAppSaving: state.app.isAppSaving,
    appState: state    
  };
};

const mapDispatchToProps = {
  saveAppState
};

const form = reduxForm({
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)((form)(Chmp));
